import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useContext, useEffect, useState } from 'react';
import { CustomButton } from '../../components/buttons';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// Tipleri context’ten alıyoruz
interface LegalContractItem {
    type: string;
    text: string;
}

interface LegalContractConsentItem {
    type: string;
    text: string;
    contractType: string;
    required: boolean;
}

export interface DialogProps {
    onClose: () => void;
    context: React.Context<any>; // hangi context kullanılacak
}

const LegalTextV2Modal = (props: DialogProps) => {
    const { onClose, context } = props;

    const { showLegalTextModal, legalTextLoading, selectedConsentType, legalTexts } = useContext(context);

    const [legalText, setLegalText] = useState('');

    useEffect(() => {
        if (showLegalTextModal && legalTexts) {
            const selectedConsent = legalTexts.consents.find(
                (x: LegalContractConsentItem) => x.type === selectedConsentType
            );
            const selectedContract = legalTexts.contracts.find(
                (x: LegalContractItem) => x.type === selectedConsent?.contractType
            );
            setLegalText(selectedContract?.text ?? '');
        }
    }, [showLegalTextModal, legalTexts, selectedConsentType]);

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            open={showLegalTextModal}
            scroll="paper"
            fullWidth={true}
            maxWidth="sm"
            onClose={handleClose}
        >
            <DialogContent>
                {legalTextLoading ? (
                    <Box width="100%" display="flex" justifyContent="center">
                        <CircularProgress thickness={5} size={30} />
                    </Box>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: legalText }}></div>
                )}
            </DialogContent>
            <DialogActions>
                <CustomButton
                    text="Kapat"
                    variant="text"
                    onClick={handleClose}
                />
            </DialogActions>
        </Dialog>
    );
};

export default LegalTextV2Modal;
